import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TwoFactorService } from '../../../../core/services/two-factor.service';
import { safeInternalReturnUrl } from '../../../../core/utils/return-url.util';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-verify-2fa',
    templateUrl: './verify-2fa.component.html',
    styleUrls: ['./verify-2fa.component.css'],
    standalone: true,
    imports: [CommonModule, FormsModule]
})
export class Verify2FAComponent {

  code = '';
  loading = false;
  errorMessage = '';
  useBackupCode = false;

  /**
   * #1315 — destination d'origine, telle que posée par le garde qui a dérouté
   * vers cet écran. Elle était produite et transportée, mais jamais lue : la
   * vérification atterrissait toujours sur `/backoffice`, y compris quand le
   * client venait chercher sa boîte VM.
   */
  private readonly returnUrl: string;

  constructor(
    private twoFactorService: TwoFactorService,
    private router: Router,
    route: ActivatedRoute,
  ) {
    this.returnUrl = safeInternalReturnUrl(
      route.snapshot.queryParams['returnUrl'],
      '/backoffice',
    );
  }

  async onVerify(): Promise<void> {
    const trimmed = this.code.trim();
    if (!trimmed) return;

    this.loading = true;
    this.errorMessage = '';

    try {
      const result = await this.twoFactorService.verify(trimmed);

      if (result.valid) {
        this.twoFactorService.mark2FAVerified();
        // `navigateByUrl` obligatoire : un returnUrl porteur d'une query string
        // passé en commande verrait son `?` encodé en `%3F` → 404.
        await this.router.navigateByUrl(this.returnUrl);
      } else {
        this.errorMessage = 'Code invalide. Veuillez réessayer.';
      }
    } catch (err: any) {
      console.error('[Verify2FA] Error:', err);
      this.errorMessage = err?.message || 'Erreur de vérification. Réessayez.';
    } finally {
      this.loading = false;
    }
  }

  toggleBackupCode(): void {
    this.useBackupCode = !this.useBackupCode;
    this.code = '';
    this.errorMessage = '';
  }

  goBack(): void {
    this.twoFactorService.clear2FASession();
    // La destination survit au retour arrière : sans ça, se reconnecter depuis
    // cet écran rejouerait exactement la perte que #1315 corrige.
    this.router.navigate(['/backoffice-login'], {
      queryParams: { returnUrl: this.returnUrl },
    });
  }
}
